import AppBanner from './app-banner';

export default AppBanner;